import React from 'react';
// import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import jwtAuthAxios from "./auth/jwtAuth";
// const {setAuthToken} = useJumboAuth();

const authServices = {
    getCurrentUser: async () => {
      try {
        return JSON.parse(localStorage.getItem('user'))
        // const { data } = await jwtAuthAxios.get("/auth");
        // return data;
      } catch (error) {
        // Handle the error here
        console.error("Error in getCurrentUser:", error);
      }
    },  
    signIn: async (loginCreds) => {
      try {
        const { data } = await jwtAuthAxios.post('/auth', loginCreds);
        return data;
      } catch (error) {
        // Handle the error here
        console.error("Error in signIn:", error);
        // throw error;
      }
    },
    // getCurrentBranch: async (token) => {
    //   try {
    //     const { data } = await jwtAuthAxios.post('/auth', {token});
    //     return data;
    //   } catch (error) {
    //     // Handle the error here
    //     console.error("Error in signIn:", error);
    //     // throw error;
    //   }
    // },
  };
  
  export default authServices;
  
